import React from "react";

const Activator = ({ channel }) => {
  const purchaseActivation = async () => {
    const orderResponse = await fetch("/api/orders", {
      credentials: "include",
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [
          {
            productId: "ACTIVATE_CONDITIONS",
            quantity: "1",
            data: { channelId: channel.id },
          },
        ],
      }),
    });

    if (!orderResponse.ok) {
      if (orderResponse.status === 401) {
        // redirect to login
        window.location.href = `${
          window.location.origin
        }/login?ref=${encodeURIComponent(window.location.pathname)}`;
      }

      // TODO: display error
      return;
    }

    const order = await orderResponse.json();

    window.location.href = `${window.location.origin}/orders/${order.id}`;
  };

  return (
    <div>
      <h2>Channel Inactive</h2>
      <p>
        Want to activate this channel? $3 AUD will open the channel for
        everyone!
      </p>

      <div onClick={purchaseActivation} className="btn primary">
        Activate
      </div>
    </div>
  );
};

export default Activator;
